// extracted by mini-css-extract-plugin
export var currency = "ItemizedResults-module--currency--ef90f";
export var divider = "ItemizedResults-module--divider--ff6ca";
export var grid = "ItemizedResults-module--grid--6f9d1";
export var results = "ItemizedResults-module--results--97544";
export var total = "ItemizedResults-module--total--39ad3";